module.exports = __webpack_public_path__ + "static/opensans-italic-webfont-a9bc3220633223c7cfe72d3f1eaa88bb.woff";